import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const taskVuex = createNamespacedHelpers("task");
export default {
  name: "popGuide",
  computed: {
    ...userVuex.mapState(["isLogin", "userInfo"]),
    ...taskVuex.mapState(["taskInfo"])
  },
  data() {
    return {
      popGuideShow: false,
      currentIndex: 0,
      guideList: []
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          this.setGuideList();
          // const gt = localStorage.getItem("gt");
          // const nowTime = this.getLocalUTCZero();
          // const nextTime = this.getNextMidnight();
          // console.log("nowTime===", nowTime, nextTime, nextTime - nowTime);
          // if (this.taskInfo.isGuide && (!gt || (gt && nowTime >= gt)) && (this.userInfo.spins >= 1 || this.userInfo.stock >= 1)) {
          //   this.popGuideShow = true;
          //   localStorage.setItem("gt", nextTime);
          // }
          // this.taskInfo.isGuide = false;

          if (this.taskInfo.isGuide && (this.userInfo.spins >= 1 || this.userInfo.stock >= 1)) {
            this.popGuideShow = true;
          }
          this.taskInfo.isGuide = false;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    setGuideList() {
      let guideList = [{
        name: null,
        img: "guide-img-botcode.jpg",
        earn: null,
        path: "/botcode",
        type: "botcode"
      }
      // {
      //   name: "SLOT",
      //   img: "guide-img-slot.jpg",
      //   earn: `<img src="${require("@images/icon/icon-hic.png")}" alt=""/>+<img src="${require("@images/icon/icon-spins.png")}" alt=""/>`,
      //   path: "/slotMachine",
      //   type: "spins",
      // },

      // {
      //   name: "LUCKY WHEEL",
      //   img: "guide-img-turn.jpg",
      //   earn: `<img src="${require("@images/icon/icon-pass.png")}" alt=""/>+<img src="${require("@images/icon/icon-usdt.png")}" alt=""/>`,
      //   path: "/turn",
      //   type: "stock",
      // },
      ];

      this.guideList = guideList;
    },
    prevSlide() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    nextSlide() {
      if (this.currentIndex < this.guideList.length - 1) {
        this.currentIndex++;
      }
    },
    //获取UTC+0次日时间
    getNextMidnight() {
      // 倒计时按UTC+0计算
      const nextUTCZero = Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate() + 1,
      // 次日
      0, 0, 0, 0);
      return Math.floor(nextUTCZero / 1000);
    },
    //获取本地时间(UTC+0)
    getLocalUTCZero() {
      const now = new Date();

      // 当前 UTC 时间的毫秒时间戳
      const utcMs = now.getTime() + now.getTimezoneOffset() * 60;
      return Math.floor(utcMs / 1000);
    },
    //获取本地时间(UTC+0) 延长第N小时时间
    getUTCPlusHours(hours = 6) {
      const now = new Date();

      // 直接基于当前时间加 N 小时（毫秒）
      const targetMs = now.getTime() + hours * 60 * 60 * 1000;
      return Math.floor(targetMs / 1000); // 返回的是 UTC+0 基础上的延后时间
    },

    popGuideConfirm() {
      if (this.guideList.length <= 0) return;
      this.popGuideShow = false;
      this.$nextTick(() => {
        this.$router.push(this.guideList[this.currentIndex].path);
      });
    }
  },
  mounted() {}
};